/**
 * Production-readiness filter for {@link LeadFlowByIdQuery}.
 *
 * `count(steps) > 0` counts step entries, not the documents they point at,
 * so a flow whose every entry references a deleted or unpublished step would
 * still pass it. A flow is ready only when it has entries and every entry
 * resolves; otherwise the runtime treats it as missing rather than rendering
 * a flow with holes in it.
 */
const leadFlowProductionReadyFilter =
  "enabled == true && count(steps) > 0 && count(steps[!defined(step->_id)]) == 0";

export { leadFlowProductionReadyFilter };
